import classes from "../styles/Settings.module.css";
import PlaybooksSettings from "./PlaybooksSettings";
import GeneralSettings from "./GeneralSettings";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Settings as SettingsIcon, BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";

interface SettingsProps {
  opened: boolean;
  close: () => void;
}

type SettingsSection = "general" | "playbooks";

export default function Settings({ opened, close }: SettingsProps) {
  const [activeSection, setActiveSection] =
    useState<SettingsSection>("general");

  const settingSections = [
    { id: "general" as const, label: "General", icon: SettingsIcon },
    { id: "playbooks" as const, label: "Playbooks", icon: BookOpen },
  ];

  const renderContent = () => {
    switch (activeSection) {
      case "playbooks":
        return <PlaybooksSettings />;
      case "general":
      default:
        return <GeneralSettings />;
    }
  };

  return (
    <Dialog open={opened} onOpenChange={(open) => !open && close()}>
      <DialogContent className={cn(classes["modal-content"], "max-w-4xl")}>
        <DialogHeader>
          <DialogTitle>Settings</DialogTitle>
        </DialogHeader>
        <div className="flex min-h-[600px]">
          {/* Sidebar */}
          <div className="w-64 border-r border-gray-200 pr-4">
            <nav className="space-y-1">
              {settingSections.map((section) => {
                const Icon = section.icon;
                return (
                  <button
                    key={section.id}
                    onClick={() => setActiveSection(section.id)}
                    className={cn(
                      "w-full text-left px-3 py-3 rounded-md text-sm transition-colors flex items-center gap-3",
                      activeSection === section.id
                        ? "bg-primary text-primary-foreground"
                        : "text-gray-600 hover:bg-gray-100 hover:text-gray-900",
                    )}
                  >
                    <Icon className="h-4 w-4" />
                    {section.label}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Content */}
          {renderContent()}
        </div>
      </DialogContent>
    </Dialog>
  );
}
